import HTTP from '@/utils/http'
import notification from '@/utils/notification'
const PREFIX_PATH = '/inspections'

export async function create (data) {
  try {
    const response = await HTTP.post(`${PREFIX_PATH}`, data)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getALL (params, isSilentGet) {
  try {
    const get = isSilentGet ? HTTP.silentGet : HTTP.get
    const response = await get(`${PREFIX_PATH}`, { params })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    return []
  }
}

export async function update (id, data) {
  try {
    const response = await HTTP.put(`${PREFIX_PATH}/${id}`, data)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function updateUpdatedAt (id) {
  try {
    const response = await HTTP.put(`${PREFIX_PATH}/${id}/updated-at`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getById (id) {
  try {
    const response = await HTTP.get(`${PREFIX_PATH}/${id}`)
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function updateTenantViewable (id, isTenantView) {
  try {
    const response = await HTTP.patch(`${PREFIX_PATH}/${id}/tenant_viewable`, { isTenantView })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function getEmailHistoriesById (id, { isSilent = false, notify = true } = {}) {
  const get = isSilent ? HTTP.silentGet : HTTP.get
  try {
    const response = await get(`${PREFIX_PATH}/${id}/email_history`)
    return response.data.data
  } catch (err) {
    notify && notification.handleResponseError(err)
    throw err
  }
}

export async function createEmailHistoriesById (id, data, { notify = true } = {}) {
  try {
    const response = await HTTP.post(`${PREFIX_PATH}/${id}/email_history`, data)
    return response.data.data
  } catch (err) {
    notify && notification.handleResponseError(err)
    throw err
  }
}

export async function updateEmailHistoriesById (id, data, { notify = true } = {}) {
  try {
    const response = await HTTP.put(`${PREFIX_PATH}/email_histories/${id}`, data)
    return response.data.data
  } catch (err) {
    notify && notification.handleResponseError(err)
    throw err
  }
}

export async function sendEmailHistoriesById (id, data, { notify = true } = {}) {
  try {
    const response = await HTTP.post(`${PREFIX_PATH}/email_histories/${id}/send`, data)
    return response.data.data
  } catch (err) {
    notify && notification.handleResponseError(err)
    throw err
  }
}
